module.exports = __webpack_public_path__ + "img/icon-regenerate.8f9c7649.svg";